import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";

const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { stateData } from "@/constants/electionConfig";
// import OldElectionScreen from "@/screens/OldStateElection";
const OldElectionScreen = dynamic(() => import("@/screens/OldStateElection"));
export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  constituencyListData = null,
  electionCategory = null,
  liveBlogData = null,
}) {
  const isMobileDevice = useIsMobile();
  // let metaData = {
  //   title: `Maharashtra Assembly Election 2024: Constituency Wise Candidate Winner List, 2024 महाराष्ट्र विधानसभा चुनाव निर्वाचन क्षेत्र उम्मीदवार`,
  //   description: `Maharashtra Assembly Elections Results 2024 (महाराष्ट्र विधानसभा चुनाव 2024 परिणाम) – Get the list of winning candidates from all major parties in the Maharashtra vidhan sabha election (विधानसभा चुनाव) 2024, along with live election news, videos, photos, and in-depth analysis on Maharashtra Election 2024.`,
  //   keywords: `Maharashtra Assembly Election  2024, 2024 Maharashtra vidhan sabha election winning candidates list, Constituency-wise vidhan sabha Winning Candidates list 2024, winning candidates list of Maharashtra Assembly election 2024, महाराष्ट्र विधानसभा चुनाव 2024, महाराष्ट्र विधानसभा चुनाव 2024 उम्मीदवारों की सूची,  list of winning candidate, election results, जीतने वाला उम्मीदवार 2024,`,
  // };

  const state_data = stateData[electionCategory];

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <OldElectionScreen
          electionPath={`${electionCategory}/constituency-list`}
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          electionPassedCategory={
            state_data?.["constituency-list"]?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.["constituency-list"]?.state} //"Delhi"
          stateHindi={state_data?.["constituency-list"]?.stateHindi} //"महाराष्ट्र"
          metaData={state_data?.["constituency-list"]?.metaData}
          constituencyListData={constituencyListData}
          liveBlogData={liveBlogData}
          staticContent={state_data?.["constituency-list"]?.staticContent}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";

  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");

  if (!stateData[electionCategory]) {
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;
    url = url.split("/constituency-list")[0];
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed, getAutoLiveBlog } = await import(
      "@/handlers/content"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    const latestLiveRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: 0,
        display: 85,
        id: "322111",
        auto_blog: "1",
        unixtime,
      },
    });

    let electionConfigData = null;
    const electionConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.[stateData[electionCategory]?.masterConfigKey];



    let constituencyListData = null;

    let constituencyUrl = electionConfigData?.constListYear == 2020 ? electionConfigData?.allConstituency2020Api : electionConfigData?.resultYear == 2024 ? electionConfigData?.allConstituency2024Api : electionConfigData?.allConstituency2025Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();

      constituencyListData = electionConfigData?.resultYear == 2024 ? data1 : data1?.data;
    }).catch((error) => {
      console.log("error", error);
      constituencyListData = null;
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // faqData,
      liveBlogData,
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
      fetchRedisWrapper(latestLiveRedisKey, () =>
        getAutoLiveBlog({
          page: 0,
          display: 85,
          id: process.env.AUTO_LIVE_BLOG || '458285',
        })
      ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        constituencyListData,
        electionCategory,
        // faqData,
        liveBlogData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
